import React from 'react';
import { Routes, Route } from 'react-router-dom';

// Import page components
import ShiftPlanning from '../pages/shiftPlanning';
import ShiftPlanLayout from '../components/ShiftPlanLayout';
import InboundTrailerVolume from '../pages/inboundTrailerVolume';
import Settings from '../pages/settings';
import StationAssignment from '../pages/stationAssignment';
import Dashboard from '../pages/flowPlanning/dashboard';
import WorkItems from '../pages/workItems';
import WorkItemDetail from '../pages/workItemDetail';
import StationAssignmentLayout from '../components/StationAssignmentLayout';
import AssociateViewPage from '../pages/stationAssignment/associateView';
import StationAssignmentHistory from '../pages/stationAssignment/history';
import PublishedAssignmentContainer from '../pages/stationAssignment/published';
import LeaderboardPage from '../pages/leaderboard';
import NavigationGuard from '../components/NavigationGuard';
import { ROUTES } from '../utils/constants';
import { useResolveStationCode } from '../hooks/useResolveStationCode';

const GeneralRouter: React.FC = () => {
    // Fallback stationCode resolution — reads ?stationCode= from the URL
    // and seeds shiftPlanSlice in Redux if not already set at store init.
    useResolveStationCode();

    return (
        <NavigationGuard>
            <div className="main-content-wrapper">
                <Routes>
                    {/* Default route */}
                    <Route path="/" element={<ShiftPlanning />} />

                    {/* Shift planning process routes - nested under ShiftPlanLayout */}
                    <Route path="/shift-plan/*" element={<ShiftPlanLayout />} />

                    {/* Legacy route for backward compatibility */}
                    <Route path="/inbound" element={<InboundTrailerVolume />} />
                    <Route path="/settings" element={<Settings />} />
                    <Route path={ROUTES.WORK_ITEMS} element={<WorkItems />} />
                    <Route path={ROUTES.WORK_ITEM_DETAIL} element={<WorkItemDetail />} />

                    {/* Shift rotation routes */}
                    <Route path="/shift-rotation" element={<StationAssignment />} />
                    <Route path={ROUTES.SHIFT_ROTATION_ASSOCIATE_VIEW} element={<AssociateViewPage />} />
                    <Route path={ROUTES.SHIFT_ROTATION_HISTORY} element={<StationAssignmentHistory />} />
                    <Route path={ROUTES.SHIFT_ROTATION_PUBLISHED} element={<PublishedAssignmentContainer />} />
                    <Route path="/shift-rotation/*" element={<StationAssignmentLayout />} />
                    <Route path="/reporting" element={<Dashboard />} />
                    <Route path={ROUTES.LEADERBOARD} element={<LeaderboardPage />} />
                </Routes>
            </div>
        </NavigationGuard>
    );
};

export default GeneralRouter;
